<script>
import Modal from '../../Modal.vue';

export default {
  components: {
    Modal,
  },
  props: {
    title: {
      type: String,
      default: 'Alert',
    },
    description: {
      type: String,
      default: '',
    },
    buttonLabel: {
      type: String,
      default: 'OK',
    },
    secondaryButtonLabel: {
      type: String,
      default: '',
    },
    primaryButtonType: {
      type: String,
      default: 'primary',
    },
    secondaryButtonType: {
      type: String,
      default: 'clear',
    },
    primaryClickHandler: {
      type: Function,
      default: null,
    },
    secondaryClickHandler: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      isVisible: false,
      resolvePromise: undefined,
      currentTitle: this.title,
      currentDescription: this.description,
      currentButtonLabel: this.buttonLabel,
      currentSecondaryButtonLabel: this.secondaryButtonLabel,
      currentPrimaryButtonType: this.primaryButtonType,
      currentSecondaryButtonType: this.secondaryButtonType,
      currentPrimaryClickHandler: this.primaryClickHandler,
      currentSecondaryClickHandler: this.secondaryClickHandler,
    };
  },
  methods: {
    resetToDefaults() {
      // Reset all configuration values to their defaults or initial prop values
      this.currentTitle = this.title;
      this.currentDescription = this.description;
      this.currentButtonLabel = this.buttonLabel;
      this.currentSecondaryButtonLabel = this.secondaryButtonLabel;
      this.currentPrimaryButtonType = this.primaryButtonType;
      this.currentSecondaryButtonType = this.secondaryButtonType;
      this.currentPrimaryClickHandler = this.primaryClickHandler;
      this.currentSecondaryClickHandler = this.secondaryClickHandler;
    },
    showAlert(options = {}) {
      console.log('AlertModal showAlert called with options:', options);
      
      // Reset to defaults first
      this.resetToDefaults();
      
      // Update all properties with provided options
      if (options.title) this.currentTitle = options.title;
      if (options.description) this.currentDescription = options.description;
      if (options.buttonLabel) this.currentButtonLabel = options.buttonLabel;
      if (options.secondaryButtonLabel !== undefined) this.currentSecondaryButtonLabel = options.secondaryButtonLabel;
      if (options.primaryButtonType) this.currentPrimaryButtonType = options.primaryButtonType;
      if (options.secondaryButtonType) this.currentSecondaryButtonType = options.secondaryButtonType;
      if (options.primaryClickHandler) this.currentPrimaryClickHandler = options.primaryClickHandler;
      if (options.secondaryClickHandler) this.currentSecondaryClickHandler = options.secondaryClickHandler;
      
      // Show the modal
      this.isVisible = true;
      console.log('AlertModal isVisible set to:', this.isVisible);
      
      return new Promise(resolve => {
        this.resolvePromise = resolve;
      });
    },
    confirm() {
      if (this.currentPrimaryClickHandler) {
        this.currentPrimaryClickHandler();
      }
      this.resolvePromise(true);
      this.isVisible = false;
      this.resetToDefaults();
    },
    cancel() {
      if (this.currentSecondaryClickHandler) {
        this.currentSecondaryClickHandler();
      }
      this.resolvePromise(false);
      this.isVisible = false;
      this.resetToDefaults();
    },
    updateVisibility(val) {
      this.isVisible = val;
      if (!val) {
        // Reset to defaults when the modal is closed
        this.resetToDefaults();
      }
    }
  },
  watch: {
    title(newTitle) {
      this.currentTitle = newTitle;
    },
    description(newDescription) {
      this.currentDescription = newDescription;
    },
    buttonLabel(newButtonLabel) {
      this.currentButtonLabel = newButtonLabel;
    },
    secondaryButtonLabel(newSecondaryButtonLabel) {
      this.currentSecondaryButtonLabel = newSecondaryButtonLabel;
    },
    primaryButtonType(newPrimaryButtonType) {
      this.currentPrimaryButtonType = newPrimaryButtonType;
    },
    secondaryButtonType(newSecondaryButtonType) {
      this.currentSecondaryButtonType = newSecondaryButtonType;
    },
    primaryClickHandler(newPrimaryClickHandler) {
      this.currentPrimaryClickHandler = newPrimaryClickHandler;
    },
    secondaryClickHandler(newSecondaryClickHandler) {
      this.currentSecondaryClickHandler = newSecondaryClickHandler;
    },
  },
};
</script>

<template>
  <Modal :show="isVisible" :on-close="cancel" @update:show="updateVisibility">
    <div class="h-auto overflow-auto flex flex-col">
      <div class="flex flex-col items-start px-8 pt-8 pb-0">
        <h2
          data-test-id="modal-header-title"
          class="text-base font-semibold leading-6 text-slate-800 dark:text-slate-50"
        >
          {{ currentTitle }}
        </h2>
        <p
          v-if="currentDescription"
          data-test-id="modal-header-content"
          class="w-full mt-2 text-sm leading-5 break-words text-slate-600 dark:text-slate-300"
          v-html="currentDescription"
        />
      </div>
      <div class="flex flex-row justify-end gap-2 py-4 px-6 w-full">
        <woot-button 
          v-if="currentSecondaryButtonLabel" 
          :variant="currentSecondaryButtonType"
          @click="cancel">
          {{ currentSecondaryButtonLabel }}
        </woot-button>
        <woot-button 
          :variant="currentPrimaryButtonType" 
          @click="confirm">
          {{ currentButtonLabel }}
        </woot-button>
      </div>
    </div>
  </Modal>
</template>
